var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"integrationPanelPage"}},[(_vm.iframeUrl)?_c('iframe',{attrs:{"src":_vm.iframeUrl,"samesite":"none","secure":"true"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }